import React from 'react';

import Icon from '../Icon/Icon';

const PlusIcon = (props) => {
    return (
        <Icon width='24' height='24' {...props}>
            <g stroke='#272A33' strokeWidth='1.5' fill='none' fillRule='evenodd' strokeLinecap='round'>
                <path d='M19.934 12.003H4.071M12.003 4.07v15.864' />
            </g>
        </Icon>
    );
};

export default PlusIcon;
